<template>
  <div id="app">
    <router-view />
    <!-- 直接渲染路由视图 -->
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import { onMounted } from "vue";

const store = useStore();

onMounted(() => {
  store.dispatch("loadPermissionsFromLocalStorage");
  store.dispatch("fetchPermissions");
});
</script>

<style lang="scss">
html,
body {
  margin: 0; /* 去掉默认边距 */
  padding: 0; /* 去掉默认内边距 */
  height: 100%; /* 确保高度为100% */
}
</style>
